import { Dialog, DialogBackdrop, DialogPanel, Transition, TransitionChild } from '@headlessui/react';
import { cn } from '@theprintbar/shared';
import { Fragment } from 'react';
import { ModalPanel, ModalPanelProps } from './ModalPanel';

export interface ModalProps extends ModalPanelProps {
	open: boolean;
	customPanel?: boolean;
	position?: ModalPosition;
}

export enum ModalPosition {
	Center = 'items-center justify-center',
	Top = 'items-start justify-center my-8 lg:my-16',
}

export function Modal({ open, children, position = ModalPosition.Top, onClose, customPanel, ...PanelProps }: ModalProps) {
	return (
		<Transition show={open} as={Fragment}>
			<Dialog
				transition
				className={cn(
					'fixed focus:outline-none inset-0 flex z-[998] transition duration-150 ease-out data-[closed]:opacity-0',
					position,
				)}
				onClose={() => onClose?.()}
			>
				<DialogBackdrop className="fixed inset-0 bg-black/70" />
				{customPanel ? (
					children
				) : (
					<ModalPanel onClose={onClose} {...PanelProps}>
						{children}
					</ModalPanel>
				)}
			</Dialog>
		</Transition>
	);
}
